import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    rating: {
        fill: '#fad043',
        marginRight: '5px'
    },
    root: {
        display: 'flex',
        alignItems: 'center',
    }
});

const Type = ({ classes, rowData, color }) => {
    //let color = Math.floor(Math.random() * 2) ? 'red' : 'green';
    return (<div className={classes.root}>
        <svg fill={color} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="15px" y="15px"
            viewBox="0 0 390 390" style={{ enableBackground: 'new 0 0 390 390', width: '15px', height: '15px' }}>
            <g>
                <circle cx="200" cy="200" r="100" />
                <path d="M375,0H15C6.716,0,0,6.716,0,15v360c0,8.284,6.716,15,15,15h360c8.284,0,15-6.716,15-15V15C390,6.716,383.284,0,375,0z
                M360,360H30V30h330V360z"/>
            </g>
        </svg>
    </div>);
}

export default withStyles(styles)(Type);